
<div #modalContainer>
  <div class="modal-header">
    <h4 class="modal-title">Newer case answers available</h4>
  </div>
  <div class="modal-body">
    <p>
      We noticed that TXdocs has newer answers than this document. Would you like to update the case answers in the
      document?
    </p>
    <p class="text-primary">
      Note: If you keep the answers in this document, changes made to those answers will not be saved to the case in TXdocs.
    </p>
  </div>
  <div class="modal-footer d-flex justify-content-between">
    <button type="button" class="btn btn-primary word-wrap-btn" (click)="handleYes()">Update answers from TXdocs</button>
    <button type="button" class="btn btn-warning word-wrap-btn" (click)="handleNoConfirmation()">Keep document answers</button>
  </div>
</div>